(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  $('.sidenav').slideReveal({
    trigger: $(".sidenavTrigger"),
    width: 400,
    overlay: true,
    overlayColor: 'rgba(0,0,0,0.5)',
    push: false,
    shown: function(sidenav, trigger){
      $('.sidenavTriggerClose').show();
    },
    hidden: function(sidenav, trigger){
      $('.sidenavTriggerClose').hide();
    },
    show: function(sidenav, trigger){
      $('.sidenavTriggerClose').show();
      $('.sidenav').css('visibility','visible');
    }
  });
  $('.searchToggle').click(function(event) {
    $('.searchholder').toggle();
    //$('.searchfield').focus();
    return false;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  jQuery(document).ready(function($) {
    $('.faq').clone().appendTo('.appendfaq');
    $(".scrollToBuy").click(function() {
      $('html, body').animate({
            scrollTop: $("h1").offset().top - 76
      }, 2000);
      return false;
    });

   $('.faq p strong').append('<i class="fa fa-plus"></i><i class="fa fa-minus"></i>');
   $('.faq p:has(strong)').addClass('question');
   
   $('body').on('click', '.question', function() {
      if ($(this).hasClass('open')) {
        $(this).removeClass('open').next('p').slideUp('fast');
      } else { 
        $('.faq p:not(.question)').slideUp('fast');
        $(this).addClass('open').next('p').slideDown('fast');
      }
   });

  $('.product-overview-toggle').click(function(event) {
    $(this).toggleClass('open');
    $('#product-overview').slideToggle();
  });

  });

  $(window).load(function() {
    if ($('.appendfaq p').length < 1 ) { 
      $('.faq-head').remove();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sidecart"]) return;
  try {
    


var sideCart = $('#shopify-section-sidecart').slideReveal({
	position: "right",
	push: false,
	width: 300,
	show: function(slider, trigger){
		//$('body').addClass('bodypadright');
	},
	hidden: function(slider, trigger){
		//$('body').removeClass('bodypadright');
	}
});

$(document).on('cart.requestStarted', function(event, cart) {
	$('#product-add').html('Adding ...');
});

$(document).on('cart.requestComplete', function(event, cart) {
	$('#shopify-section-sidecart').css('visibility','visible');
	sideCart.slideReveal("show");
	$('.fixedtop').css('position', 'fixed');
	$('.cartcount').text(cart.item_count);
	$('#product-add').html('Add to Cart  <i class="fa fa-cart-plus"></i>');
});

$(document).on('cart.ready', function(event, cart) {
   	//sideCart.slideReveal("show");
});

$('.opencart').click(function(event) {
	$('#shopify-section-sidecart').css('visibility','visible');
	sideCart.slideReveal("show");
	$('.fixedtop').css('position', 'fixed');
	return false;
});
$('.closecart').click(function(event) {
	sideCart.slideReveal("hide");
	$('#shopify-section-sidecart').css('visibility','hidden');
	$('.fixedtop').css('position', 'absolute');
	return false;
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  $('.testislider').slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    dots: false,
    arrows:false,
	responsive: [
	    {
	      breakpoint: 768,
	      settings: {
	        slidesToShow: 1,
	        slidesToScroll: 1,
	        dots: true
	      }
	    }
	  ]
  });

  } catch(e) { console.error(e); }
})();
})();
